import React from 'react';

function CopyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_1701_6768)">
        <path
          d="M8.20988 14H2.93827C1.2963 14 0 12.7037 0 11.0617V5.79012C0 4.14815 1.2963 2.85185 2.93827 2.85185H8.20988C9.85185 2.85185 11.1481 4.14815 11.1481 5.79012V11.0617C11.1481 12.7037 9.85185 14 8.20988 14ZM2.93827 4.58025C2.24691 4.58025 1.72839 5.09876 1.72839 5.79012V11.0617C1.72839 11.7531 2.24691 12.2716 2.93827 12.2716H8.20988C8.90123 12.2716 9.41975 11.7531 9.41975 11.0617V5.79012C9.41975 5.09876 8.90123 4.58025 8.20988 4.58025H2.93827ZM14 9.16049V3.62963C14 1.64198 12.358 0 10.3704 0H4.83951C4.32099 0 3.97531 0.345679 3.97531 0.864197C3.97531 1.38272 4.32099 1.72839 4.83951 1.72839H10.3704C11.4074 1.72839 12.2716 2.59259 12.2716 3.62963V9.16049C12.2716 9.67901 12.6173 10.0247 13.1358 10.0247C13.6543 10.0247 14 9.67901 14 9.16049Z"
          fill="#FF8A00"
        />
      </g>
      <defs>
        <clipPath id="clip0_1701_6768">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CopyIcon;
